// Upload slice
import { StateCreator, StoreApi } from "zustand";
import { AppStoreState } from "../appStore";

type SetState = StoreApi<AppStoreState>["setState"];

const createUploadSlice: StateCreator<
  AppStoreState,
  [],
  [],
  Pick<AppStoreState, "uploadDocuments">
> = (set: SetState) => ({
  uploadDocuments: async (files: File[], uploadPath: string) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("file", file, file.name);
    });
    const response = await fetch(uploadPath, {
      method: "POST",
      body: formData,
    });
    return response.json();
  },
});

export default createUploadSlice;
